import React from 'react';
import {
    FaTable,
    FaChartPie,
    FaCalculator,
    FaCode,
    FaFileContract,
    FaFileImport,
    FaFlask,
    FaClipboardList,
    FaChartLine
} from 'react-icons/fa'
import { MdOutlineSettings } from "react-icons/md";

const navigation = [
    {
        label: 'Dashboard',
        href:  '/dashboard',
        icon: <FaChartPie />,
        key : 'dashboard',
        color: '#6265EA',
        order: 1
    },
    {
        label: 'Projetos',
        href:  '/projetos',
        icon: <FaCode />,
        key : 'projetos',
        color: '#8B22E8',
        order: 2
    },
    {
        label: 'Simulações',
        href: '/simulacoes',
        icon: <FaFlask />,
        key: 'simulacoes',
        color: '#e76f51',
        order: 3
    },
    {
        label: 'Fechamentos',
        href: '/fechamentos',
        icon: <FaCalculator />,
        key : 'fechamentos',
        color: 'red',
        order: 4
    },
    {
        label: 'Forecast',
        href: '/forecast',
        icon: <FaChartLine />,
        key: 'forecast',
        allowedRoles: ['forecast', 'forecast-admin'],
        color: '#2196F3',
        order: 5
    },
    {
        label: 'Relatórios Delivery',
        href:  '/relatorios-delivery/',
        icon: <FaClipboardList />,
        key : 'relatorios-delivery',
        color: '#c7b108',
        order: 6
    },
    {
        label: 'Relatórios DP',
        href:  '/relatorios',
        icon: <FaFileContract />,
        key : 'relatorios',
        color: 'green',
        order: 7
    },
    {
        label: 'Cadastros',
        href:  '/cadastros',
        icon: <FaTable />,
        key : 'cadastros',
        color: '#77C3D0',
        order: 8
    },
    /* {
        label: 'Importações',
        href:  '/importacoes',
        icon: <FaFileImport />,
        key : 'importacoes',
        color: '#77C3D0',
        order: 8
    }, */
    {
        label: 'Painel de controle',
        href:  '/painel-controle',
        icon: <MdOutlineSettings />,
        key : 'painel-controle',
        color: '#010101',
        order: 9
    },
]

const subgroups = {
    'cadastros': [
        {
            label: 'Unidades',
            href: '/filial',
            key : 'cadastros-filial',
            order: 1
        },
        {
            label: 'Colaboradores',
            href: '/colaboradores',
            key : 'cadastros-colaborador',
            order: 2
        },
        {
            label: 'Custos Adicionais',
            href: '/custos-adicionais',
            key : 'cadastros-beneficio',
            order: 3
        },
        {
            label: 'Funções',
            href: '/funcoes',
            key : 'cadastros-funcao',
            order: 4
        },
        {
            label: 'Departamentos',
            href: '/departamentos',
            key : 'cadastros-departamento',
            order: 5
        },
        {
            label: 'Regimes de contrato',
            href: '/regime-contrato',
            key : 'cadastros-regime-contrato',
            order: 6
        },
        {
            label: 'Impostos',
            href: '/impostos',
            key : 'cadastros-imposto',
            order: 7
        },
        {
            label: 'Valores Financeiros Gerais',
            href: '/valores-financeiros',
            key : 'financeiro',
            order: 8
        },
        {
            label: 'Cargas Horárias',
            href: '/carga-horaria',
            key : 'cadastro-carga-horaria',
            order: 9
        },
    ],
    //'importacoes': [
        //{
        //    label: 'Atualizar colaboradores',
        //    href: '/Atualizar-colaboradores',
        //    key: 'importacoes-atualizar-colaboradores',
        //    order: 3
        //},
        //{
        //    label: 'Novos colaboradores',
        //    href: '/colaboradores',
        //    key : 'importacoes-colaborador',
        //    order: 1
        //},
        //{
        //    label: 'Benefícios de colaboradores',
        //    href: '/beneficios-colaborador',
        //    key : 'importacoes-beneficio-colaborador',
        //    order: 2
        //},
    //],
    'projetos': [
        {
            label: 'Detalhes',
            href: '/',
            key : 'projetos',
            order: 1
        },
        {
            label: 'Meus Relatórios de Margem',
            href: '/meus/relatorios/margem',
            key : 'importacoes-beneficio-colaborador',
            order: 2
        },
    ],
    'simulacoes': [
        {
            label: 'Colaboradores',
            href: '/',
            key : 'simulacoes',
            order: 1
        },
        {
            label: 'Squads',
            href: '/my-teams',
            key : 'simulacao-squad',
            order: 2
        },
        {
            label: 'Resultados',
            href: '/results',
            key : 'simulacao-resultados',
            order: 3
        }
    ],
    'forecast': [
        {
            label: 'Acompanhamento do Forecast',
            href: '/acompanhamento',
            key: 'forecast-acompanhamento',
            allowedRoles: ['forecast', 'forecast-admin'],
            order: 1
        },
        {
            label: 'Criar Forecast',
            href: '/criar',
            key: 'forecast-criar',
            allowedRoles: ['forecast-admin'],
            order: 2
        }
    ],

    // { // @TODO: Desativado p/ MVP. Implementação futura
    //     label: 'Lançamentos',
    //     href: '/lançamentos'
    // },

}

const NavigationData = {
    navigation,
    subgroups
};

export default NavigationData;
